import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const EmptyListWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 92px auto 0;

    @media (max-width: ${breakpoints.md}px) {
        margin: 34px auto 0;
        max-width: 290px;
    }
`;

export const Title = styled(Typography.TextH3_24_34)(
    ({ theme: { fontSize } }) => css`
        margin: 20px 0 12px;
        max-width: 560px;
        text-align: center;

        @media (max-width: ${breakpoints.md}px) {
            font-size: ${fontSize[20]}px;
            line-height: 28px;
        }
    `,
);

export const Description = styled(Typography.TextBody_14_24)`
    max-width: 390px;
    text-align: center;
`;
